import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase';

const IDENTIFICATION_CODE_LENGTH = 6;
const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

export function generateIdentificationCode() {
  let result = '';
  for (let i = 0; i < IDENTIFICATION_CODE_LENGTH; i += 1) {
    result += LETTERS[Math.floor(Math.random() * LETTERS.length)];
  }
  return result;
}

export async function generateUniqueIdentificationCode() {
  let unique = false;
  let code = '';
  while (!unique) {
    code = generateIdentificationCode();
    const q = query(collection(db, 'hairstylists'), where('identificationCode', '==', code));
    const snapshot = await getDocs(q);
    unique = snapshot.empty;
  }
  return code;
}

export default generateUniqueIdentificationCode;

